module.exports = __webpack_public_path__ + "img/bny-detail-2.1f4903f7.png";